import { render, staticRenderFns } from "./trackedItems.vue?vue&type=template&id=2c5238a2"
import script from "./trackedItems.js?vue&type=script&lang=js&external"
export * from "./trackedItems.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports